/**
 * Pure URL builders for the links this feature hands off to other features
 * (brief §content: "Öva detta / Practice this", "Öva liknande / Practice
 * similar", "Skriv som övningstenta / Sit as a practice exam"). Kept pure and separate
 * from the pages so the exact query-string shape is unit-tested directly
 * rather than only indirectly through a click handler.
 */

/** `/practice?chapters=<chapter>&topics=<topic>` — the same convention
 * `practice/Page.tsx` reads (`?chapters=&topics=`) and `progress`'s "study
 * next" and the exam result's "practice your weakest chapters" links use. */
export function practiceHref(chapter: number, topic: string): string {
  const params = new URLSearchParams();
  params.set("chapters", String(chapter));
  params.set("topics", topic);
  return `/practice?${params.toString()}`;
}

/** `/exam?past=<term>` — the exam feature's past-exam mode (spec §4.5). */
export function sitOldExamHref(exam: string): string {
  return `/exam?past=${encodeURIComponent(exam)}`;
}

/** `/exam?paper=<PE-nn>` — the exam feature's practice-paper mode (integration pass 2). */
export function sitPracticePaperHref(paper: string): string {
  return `/exam?paper=${encodeURIComponent(paper)}`;
}
